import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Table, Skeleton, Row, Col, AutoComplete, Divider, Input } from "antd";
import { getAllFloatingTransferItem } from "../../../actions/transfer";
import Rendertable from "./Rendertable";

const { Search } = Input;
const FloatingTransfer = ({getAllFloatingTransferItem}) => {
  const [List, setList] = useState([]);
  const [data, setData] = useState([]);
  // const [reload, setreload] = useState(false);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const pageRef = useRef(1); 
  const pageSizeRef = useRef(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalQuantity, setTotalQuantity] = useState(0);

  useEffect(() => {
    fetchData(pageRef.current, pageSizeRef.current,searchTerm);
  }, [searchTerm]);

  const fetchData = (page, pageSize, keyword = "") => {
    setLoading(true);
    getAllFloatingTransferItem({  page: page, page_size: pageSize, keyword: keyword }).then((response) => {
      setData(response.results); 
      setTotal(response.count);  
      setLoading(false);
      setTotalQuantity(response.total_quantity || 0);
    });
  };

  const handleTableChange = (page, pageSize) => {
    // const { pageSize, page } = pagination;
    pageRef.current = page;
    pageSizeRef.current = pageSize;
    fetchData(page, pageSize, searchTerm);
  };

  const onSearch = (value) => {
    setSearchTerm(value); 
    pageRef.current = 1;
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Search
            placeholder="Search Transfer Number, SKU"
            onSearch={onSearch}
            enterButton
          />
        </Col>
        <Col span={4}></Col>
        <Col span={8}>
          <div>Total Quantity: {totalQuantity}</div>
        </Col>
      </Row>
      <Divider/>
      <Rendertable
        data={data}
        loading={loading}
        total={total}
        current={pageRef.current}
        pageSize={pageSizeRef.current}
        onChange={handleTableChange}
        />
    </>
  );

};

export default connect(null, {
  getAllFloatingTransferItem
})(FloatingTransfer);
